<template>
  <section class="section" v-if="tokenUser">
    <Table :tokenUser="tokenUser" :data="companies" :filter="filter" @setFilter="setFilter" @updateCompany="updateCompany" @switchSideMenu='switchSideMenu'/>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Table from '../components/Table.vue';

export default {
  data() {
    return {}
  },
  props: {
    companies: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  computed: {
    ...mapState(["tokenUser"])
  },
  methods:{
    setFilter(value){
      this.$emit('setFilter', value)
    },
    switchSideMenu(){
      this.$emit('switchSideMenu')
    },
    updateCompany(data){
      this.$emit('updateCompany', data)
    }
  },
  components: {
    Table
  }
}
</script>
<style lang="scss" scoped>
.section {
  padding: 2.3rem 1.5rem 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/empresas/layaout/Content.vue